module.exports = new __parcel__URL__("connected_earth_greenhouse_gas.b149c337.png").toString();